import { create } from 'zustand'
import { authApi, setTokens, clearTokens, startSession } from '@carrent/api'

export const useAuthStore = create((set, get) => ({
  user: null,
  isLoading: true,

  setUser: (user) => set({ user }),

  login: (user, access_token, refresh_token) => {
    setTokens(access_token, refresh_token)
    // Новая сессия входа: идентификатор не должен тянуться
    // с экрана логина и от предыдущего пользователя.
    startSession()
    set({ user })
  },

  logout: () => {
    clearTokens()
    set({ user: null })
  },

  setLoading: (isLoading) => set({ isLoading }),

  // Перечитать профиль с сервера и обновить стор
  // Вызывать после любого действия меняющего статус (submit, verify и т.д.)
  refreshUser: async () => {
    try {
      const { data } = await authApi.me()
      set({ user: data.data })
      return data.data
    } catch {
      return null
    }
  },

  isAdmin: () => {
    const u = get().user
    return u?.role === 'admin' || u?.role === 'manager'
  },

  isApproved: () => get().user?.status === 'approved',
}))
